import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { CommonApi } from 'SRC/modules/common/api'
import { Notification } from 'react-notification'
import Router from 'next/router'
import { debounce } from 'throttle-debounce'
import { AdditionalPreloader } from 'SRC/ui/Preloader'
import { getIsAuthorized } from 'SRC/modules/users/Auth/selectors'
import { fetchCountries } from 'SRC/modules/geoObjects/countries/actions'
import { getCountries } from 'SRC/modules/geoObjects/countries/selectors'
import { fetchAdsWithPromos } from 'SRC/modules/ads/list/actions'
import { getAdsWithPromos, getAdsWithPromoLoading, getAdsWithPromosQuery } from 'SRC/modules/ads/list/selectors'
import { Item as PromoItem } from 'SRC/modules/ads/add/components/FormPage/PromoPeriodsNew/Item'
import { AdsWithPromosPagination } from 'SRC/modules/ads/paginationWithPromos/components'
import { Wrapper } from 'SRC/ui/FormElementsNew'
import config from 'SRC/config/config.yaml'

export class ActivatePromoCKB extends React.PureComponent {
  constructor(props) {
    super(props)

    const { fetchCountries, adQuery } = props

    const dial = '382'
    let phone = ''

    if (adQuery && adQuery.phone) phone = adQuery.phone.replace(dial, '')

    fetchCountries()

    this.cookies = new CookiesHelper()

    this.state = {
      phone,
      dial,
      activeListing: null,
      currentAd: null,
      country: 1,
      bankartError: '',
      bankartLoading: false
    }
  }

  prepareCountries = () => this.props.countries.filter(country => !country.parent).map(country => {
    const isGrouped = Boolean(this.props.countries.filter(item => item.parent === country.id).length)
    return {
      id: country.id,
      label: country.label,
      isGrouped,
      isDisabled: false,
      value: country.id,
      options: isGrouped ? this.props.countries.filter(item => item.parent === country.id).map(item => ({
        value: item.id,
        isDisabled: false,
        label: item.label
      })) : null
    }
  })

  setDial = e => {
    const { countries } = this.props
    const selectedCountry = e.target.value
    const country = countries.find(country => country.id === Number(selectedCountry))

    if (country && country.dial) {
      this.setState({ dial: country.dial, country: country.id })
    }
  }

  onPromoClicked = (ad, promo) => {
    this.setState({ currentAd: ad, activeListing: promo }, () => this.goToBank())
  }

  onPhoneChanged = debounce(2000, () => {
    const { dial, phone } = this.state
    const phoneParam = `${dial}${phone.replace(/ /g, '')}`

    console.log('phoneParam', phoneParam)

    const href = {
      pathname: '/activatePromoCKB',
      query: { phone: phoneParam, page: 1 }
    }
    const as = `/online-placanje/1?phone=${phoneParam}`

    Router.push(href, as)
  })

  goToBank = async () => {
    const { dial, phone, activeListing, currentAd } = this.state
    const { isAuthorized } = this.props

    let bankUrl = 'https://ecommerce.2bi.me/oglasime/PaymentInit.php'
    const selectedListing = activeListing

    if (selectedListing) {
      const bankartTransactionBody = {
        phone: `${dial}${phone.replace(/ /g, '')}`,
        amount: `${selectedListing.price}`,
        listing: selectedListing.id,
        adCode: currentAd.code
      }

      this.setState({ bankartLoading: true, bankartError: '' })

      const api = new CommonApi()
      const response = await api.getBankartTransaction(bankartTransactionBody)
      if (response?.success && response?.redirectUrl) {
        window.location.href = response.redirectUrl
      } else {
        this.setState({ bankartError: response?.message || 'Došlo je do greške' })
      }
    }
  }

  renderPhoneField = () => {
    const { dial, phone, country } = this.state

    const countries = this.prepareCountries()

    return (
      <div className='online-payment__fields'>
        <div className='form-group'>
          <label>Država</label>
          <select onChange={this.setDial} value={country}>
            {countries.map(country => {
              if (country.isGrouped) {
                return <optgroup key={country.id} label={country.label}>
                  {country.options.map(countryChild => <option key={countryChild.id} value={countryChild.value}>{countryChild.label}</option>)}
                </optgroup>
              } else {
                return <option key={country.id} value={country.value}>{country.label}</option>
              }
            })}
          </select>
        </div>

        <Wrapper>
          <label>Telefon</label>
          <div className='form-telefon__container'>
            <span className='form-group__mask'>{`+${dial}`}</span>
            <input
              onChange={e => {
                const value = e.target.value

                this.setState({ phone: value }, this.onPhoneChanged)
              }}
              defaultValue={phone}
              className={'form-group__phone'}
              type='text'
              placeholder='Upiši broj telefona'
            />
          </div>
        </Wrapper>
      </div>
    )
  }

  renderAdItem = item => {
    const { activeListing, currentAd, bankartLoading } = this.state

    let titleFormatted = item.titleCompiled || ''

    if (titleFormatted.length >= 50) {
      titleFormatted = `${titleFormatted.substring(0, 49)}...`
    }

    return (
      <React.Fragment>
        <div className='oglas-item__left'>
          <h1 className='moji-oglasi-item-heading'>{titleFormatted}</h1>
          <p className='oglas-item-ad-code'>Šifra oglasa: {item.code}</p>
          <div className='moji-oglasi-item-img'>
            <div
              className={'oglas-item-slika'}
              style={{ backgroundImage: `url(${item.image})`, 'min-height': '126px' }}
            />
          </div>
        </div>

        <div className='oglas-item__right'>

          <div className='tipovi-oglasa'>
            {Array.isArray(item.listings) ? item.listings.map(listing => (
              <PromoItem
                key={`promo-item-${listing.id}`}
                buttonText='Uplati'
                isActive={activeListing && activeListing.id === listing.id && currentAd.code === item.code}
                disabled={bankartLoading}
                {...listing}
                onClick={() => this.onPromoClicked(item, listing)}
              />
            )) : null
            }
          </div>
        </div>
      </React.Fragment>
    )
  }

  renderAds = () => {
    const { ads, adsLoading } = this.props

    if (adsLoading) {
      return <AdditionalPreloader />
    }

    if (!Array.isArray(ads) || !ads.length) {
      return <div className='oglasi-content-text__no-ads-text' style={{ textAlign: 'center' }}>Trenutno nema oglasa</div>
    }

    return (
      <section className='moji-oglasi-content'>
        {ads.map((ad, index) => <div key={`ad-${index}`} className='moji-oglasi-item'>{this.renderAdItem(ad)}</div>)}
      </section>
    )
  }

  render() {
    const { isForApp } = this.props
    const { bankartError } = this.state

    return (
      <section className={`online-payment ${isForApp ? 'online-payment-app' : ''}`}>
        {this.renderPhoneField()}

        {this.renderAds()}

        {/* <div className='bank-transfer-link' style={{ border: 'none' }}>
          <div className='bank-transfer-link__cards'>
            <img width={isForApp ? 48 : 64} src='/icons/visa.svg' />
            <img width={isForApp ? 48 : 64} src='/icons/mastercard.svg' />
            <img width={isForApp ? 48 : 64} src='/icons/american-express.svg' />
            <img width={isForApp ? 48 : 64} src='/icons/discover.svg' />
          </div>
        </div> */}
        <AdsWithPromosPagination />

        <Notification
          isActive={Boolean(bankartError)}
          message={bankartError || ``}
          action={'Sakrij'}
          onClick={() => this.setState({ bankartError: '' })}
        />
      </section>
    )
  }
}

const mapStateToProps = state => {
  const countries = getCountries(state)

  return {
    countries,
    isAuthorized: getIsAuthorized(state),
    ads: getAdsWithPromos(state),
    adsLoading: getAdsWithPromoLoading(state),
    adQuery: getAdsWithPromosQuery(state)
  }
}

ActivatePromoCKB.propTypes = {
  isForApp: PropTypes.bool.isRequired,
  countries: PropTypes.array.isRequired,
  isAuthorized: PropTypes.bool.isRequired,
  ads: PropTypes.array.isRequired,
  adQuery: PropTypes.shape({ phone: PropTypes.string }).isRequired,
  adsLoading: PropTypes.bool.isRequired,
  fetchCountries: PropTypes.func.isRequired,
  fetchAdsWithPromos: PropTypes.func.isRequired
}

ActivatePromoCKB.defaultProps = {
  listings: []
}

export default connect(mapStateToProps, { fetchAdsWithPromos, fetchCountries })(ActivatePromoCKB)
